import React, { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IProps {
    children: ReactNode;
}

export function RoutesContainer({children}: IProps) {
    let location = useLocation();

    useEffect(() => {
        let path = location.pathname.substring(1).split('/').join(' ');
        if (path.length === 0) {
            path = 'home';
        }

        document.body.className = path;
    }, [location]);

    return <>{children}</>;
}
